import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";
import CookieBanner from "@/components/feature/CookieBanner";
import PageSEO from "@/components/feature/PageSEO";
import HeroSection from "./components/HeroSection";
import ServicesGrid from "./components/ServicesGrid";
import TrustCounters from "./components/TrustCounters";
import WhyUs from "./components/WhyUs";
import ServiceAreas from "./components/ServiceAreas";
import Testimonials from "./components/Testimonials";
import HomeCTA from "./components/HomeCTA";

export default function Home() {
  return (
    <div style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <PageSEO
        title="Vaciado de Pisos Girona | GIROBUIT — Presupuesto Sin Compromiso"
        description="Vaciado de pisos y locales en Girona. Limpieza por síndrome de Diógenes, retirada de muebles y pintura final. Servicio discreto y urgente. Llama: 602 36 59 96."
        canonical="https://girobuit.com/"
        pageType="WebPage"
        breadcrumbs={[
          { name: "Inicio", url: "https://girobuit.com/" },
        ]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesGrid />
        <TrustCounters />
        <WhyUs />
        <ServiceAreas />
        <Testimonials />
        <HomeCTA />
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieBanner />
    </div>
  );
}
